// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"searchResults_searchResults__Me2UL","searchResultsConjugation":"searchResults_searchResultsConjugation__2KjCz"};